import React, { useState } from 'react';
import { ArrowPathIcon, UserPlusIcon } from '@heroicons/react/24/outline';
import SpeakersList from './SpeakersList';
import AddSpeakerModal from '../Modals/AddSpeakerModal';
import RenameSpeakerModal from '../Modals/RenameSpeakerModal';
import DeleteSpeakerModal from '../Modals/DeleteSpeakerModal';

/**
 * Sidebar — speakers + text operations (replace all, assign to speaker).
 */
const Sidebar = ({
  speakers,
  onSelectSpeaker,
  onAddSpeaker,
  onRenameSpeaker,
  onDeleteSpeaker,
  onReplaceAll,
  onAssignSelectionToSpeaker,
  selectedText,
  selection,
  className = '',
}) => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [showRenameModal, setShowRenameModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedSpeaker, setSelectedSpeaker] = useState(null);

  const handleAddSpeaker = (speakerName) => {
    const result = onAddSpeaker?.(speakerName);
    if (result) {
      if (result.success) {
        alert(result.message || 'Speaker added successfully!');
      } else {
        alert('Error: ' + (result.error || 'Failed to add speaker'));
      }
    }
  };

  const handleRenameSpeaker = async (oldName, newName) => {
    await onRenameSpeaker?.(oldName, newName);
  };

  const handleDeleteSpeaker = async (speakerName, mergeToSpeaker) => {
    await onDeleteSpeaker?.(speakerName, mergeToSpeaker);
  };

  return (
    <div className={`te-sidebar ${className}`}>
      <div className="te-sidebar-section">
        <SpeakersList
          speakers={speakers}
          onSelectSpeaker={onSelectSpeaker}
          onAddSpeaker={() => setShowAddModal(true)}
          onRenameSpeaker={(speaker) => {
            setSelectedSpeaker(speaker);
            setShowRenameModal(true);
          }}
          onDeleteSpeaker={(speaker) => {
            setSelectedSpeaker(speaker);
            setShowDeleteModal(true);
          }}
        />
      </div>

      {(onReplaceAll || onAssignSelectionToSpeaker) && (
        <div className="te-sidebar-section">
          <h3 className="te-sidebar-section-title">Text operations</h3>
          <div className="te-sidebar-actions">
            {onReplaceAll && (
              <button
                onClick={() => {
                  if (selectedText) {
                    onReplaceAll(selectedText);
                  } else {
                    const text = prompt('Enter text to replace:');
                    if (text) {
                      onReplaceAll(text);
                    }
                  }
                }}
                disabled={!selectedText}
                className="te-btn te-btn-secondary"
                title={selectedText ? `Replace all occurrences of "${selectedText}"` : 'Select text first or enter text to replace'}
              >
                <ArrowPathIcon className="h-4 w-4" />
                Replace all
              </button>
            )}
            {onAssignSelectionToSpeaker && (
              <button
                onClick={() => {
                  if (selection && selection.range && selection.text) {
                    onAssignSelectionToSpeaker(selection);
                  }
                }}
                disabled={!selection || !selection.range || !selection.text}
                className="te-btn te-btn-secondary"
                title={selection?.text ? `Assign selected text to a speaker` : 'Select text first to assign to a speaker'}
              >
                <UserPlusIcon className="h-4 w-4" />
                Assign to speaker
              </button>
            )}
          </div>
          {selectedText ? (
            <p className="te-sidebar-note">Selected: "{selectedText}"</p>
          ) : (
            <p className="te-sidebar-note">Select text in a block to enable.</p>
          )}
        </div>
      )}

      <AddSpeakerModal
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        onAdd={handleAddSpeaker}
      />
      <RenameSpeakerModal
        isOpen={showRenameModal}
        onClose={() => {
          setShowRenameModal(false);
          setSelectedSpeaker(null);
        }}
        onRename={handleRenameSpeaker}
        currentName={selectedSpeaker}
      />
      <DeleteSpeakerModal
        isOpen={showDeleteModal}
        onClose={() => {
          setShowDeleteModal(false);
          setSelectedSpeaker(null);
        }}
        onDelete={handleDeleteSpeaker}
        speakerName={selectedSpeaker}
        availableSpeakers={speakers}
      />
    </div>
  );
};

export default Sidebar;
